import FileUpload from './FileUpload';
import React from 'react';

export default function FileUploadView(props)
{
    return <FileUpload {...props} />;
}